import { useEffect, useState } from "react"
import { useIntl } from "react-intl";
import useFetchWrapper, { HttpResponse } from "../../../Helpers/useFetchWrapper";
import { Props, ResourceResponse, TabStatus, TableData } from "./PublishedResourcesTab.model";
import moment from "moment";

export const pageSize = 10;

export const usePublishedResourcesTab = ({filters}:Props) => {
  const [resources, setResources] = useState<TableData[]>();
  const [ publishedResourcesPagination, setPublishedResourcesPagination ] = useState({ page: 1, size: pageSize, total: 0 });
	const [tabStatus, setTabStatus] = useState<TabStatus>(TabStatus.Loading);
	const [deletePopup, setDeletePopup] = useState<string>('');
  const { get, put, remove } = useFetchWrapper();
  const intl = useIntl();

	useEffect(() => {
		if (publishedResourcesPagination.page > 1) {
			setPublishedResourcesPagination({
				...publishedResourcesPagination,
				page: 1,
			});
		} else {
			getResources();
		}
	}, [filters]);

  useEffect(() => {
    getResources()
  }, [publishedResourcesPagination.page])

  const getResources = async () => {
    const response: HttpResponse<ResourceResponse> = await get(`/resource/global?status=Published&page=${publishedResourcesPagination.page}&size=${publishedResourcesPagination.size}&${filters}`);
    if (response.parsedBody) {
      const resources: TableData[] = response.parsedBody.resources.map((item, index) => ({
        author: !item.author.isDeleted ? `${item.author.firstName} ${item.author.lastName}` : intl.formatMessage({id: "userLabels.deletedUser"}),
        date: moment(item.createdAt).format("DD MMM YYYY"),
        id: item.id,
				key: index,
        tags: item.researchFields,
        title: item.title,
        type: item._type
			}));
      setResources(resources);
      setPublishedResourcesPagination({...publishedResourcesPagination, total: response.parsedBody.count})
      setTabStatus(TabStatus.Loaded)
    }
    else {
      setTabStatus(TabStatus.Error);
    }
	}

	const deleteResource = async (id: string) => {
    await remove(`/resource/personal/${id}`);
		getResources();
    setDeletePopup('');
  }

  const unpublishResource = async (id: string) => {
    await put(`/resource/admin/${id}`, { Reject: {} });
    getResources();
  }

  const onChangePublishedResourcesPagination = (page: number) => {
		setPublishedResourcesPagination({ ...publishedResourcesPagination, page, });
	}
  
	return {
		deleteResource,
		getResources,
		onChangePublishedResourcesPagination,
		setDeletePopup,
		state: { deletePopup, publishedResourcesPagination, resources, tabStatus },
		unpublishResource
  }
}